import { FreePlayDiceRollDialogContainer } from './FreePlayDiceRollDialogContainer.tsx';
import { mountDialogUIReactComponent } from '../ui_platform/mountDialogUIReactComponent.tsx';
const renderFreePlayDiceRollDialog = mountDialogUIReactComponent(FreePlayDiceRollDialogContainer);
export function showFreePlayDiceRollDialog(eligibleRolls) {
    renderFreePlayDiceRollDialog({
        eligibleRolls: eligibleRolls
    });
}
